import bob from './bob';

export { default as ServiceError } from './ServiceError';

export default {
  bob,
};
